import { useState } from 'react';

type CopiedValue = string | null;
type CopyFunction = (text: string) => Promise<boolean>;

export const useCopy = (): [CopiedValue, CopyFunction] => {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFunction = async (text) => {
    if (!navigator?.clipboard) return false;

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      setTimeout(() => setCopiedText(null), 5000);
      return true;
    } catch {
      setCopiedText(null);
      return false;
    }
  };

  return [copiedText, copy];
};
